// src/utils/copyToClipboard.js

// 终极兼容版：纯同步容器复制法
export const copyText = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  
  textarea.setAttribute('readonly', 'readonly');
  textarea.style.cssText = `
    position: fixed;
    left: -9999px;
    top: -9999px;
    opacity: 0;
  `;
  
  document.body.appendChild(textarea);
  
  textarea.select();
  textarea.setSelectionRange(0, text.length); // 兼容 iOS

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.error('容器复制被拦截:', err);
    success = false;
  } finally {
    document.body.removeChild(textarea);
  }
  
  return success;
};

// 创建居中 Toast 提示
export const showCenterToast = (message, isSuccess = true) => {
  const toast = document.createElement('div');
  toast.innerText = message;
  toast.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${isSuccess ? '#10B981' : '#EF4444'};
    color: white;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 16px;
    z-index: 10000;
    box-shadow: 0 6px 20px rgba(0,0,0,0.2);
    pointer-events: none;
  `;
  document.body.appendChild(toast);

  setTimeout(() => {
    if (toast.parentNode) {
      document.body.removeChild(toast);
    }
  }, 2000);
};